import { gql } from '@apollo/client';

const REVIEW_HOLTER_BEATS_MUTATION = gql`
  mutation reviewHolterBeats($input: ReviewHolterBeatsInput!) {
    reviewHolterBeats(input: $input) {
      isSuccess
      message
    }
  }
`;

export default REVIEW_HOLTER_BEATS_MUTATION;
